import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import Navbar from "../../../components/layout/navbar";
import Icon from "../../../assets/icons";
import Tab from "../../../components/tab";
import { showToast } from "../../../components/toast";
import { RingLoader } from "react-spinners";
import { I_ProductData, I_Profile } from "../types";
import { capitalizeFirstLetter } from "../../../utilz/function";
import SingleProduct from "./product-tab/product-details";
import VariantsTable from "./variants-tab";
import ActionModal from "./action-modal";
import AddProductDialog from "./inventory";
import Button from "../../../components/button";

const ProductDetails = () => {
  const [inventory, setInventory] = useState<I_ProductData>();
  const [variants, setVariants] = useState<I_ProductData[]>([]);
  const { id } = useParams<{ id: string }>();
  const [productrModal, setProductrModal] = useState(false);
  const navigate = useNavigate();
  const [activeProduct, setActiveProduct] = useState("Product Details");
  const [modalConfig, setModalConfig] = useState<{
    isVisible: boolean;
    actionType: "approve" | "delete" | "decline";
  }>({
    isVisible: false,
    actionType: "approve",
  });

  const [profile, setProfile] = useState<I_Profile | null>(null);
  const userToken = localStorage.getItem("token");
  const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
  });
  const { makeRequest: getInventoryById } = useRequest(
    `/inventory/${id}`,
    "GET"
  );

  const { makeRequest: deleteInventory } = useRequest(
    `/inventory/${id}`,
    "DELETE"
  );

  const { makeRequest: approveInventory, loading } = useRequest(
    `/inventory/${id}/approve`,
    "POST",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const { makeRequest: rejectInventory } = useRequest(
    `/inventory/${id}/reject`,
    "POST",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getInventoryById();
      setInventory(response?.data || []);
      setVariants(response?.data || []);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);

  const handleConfirmAction = async () => {
    if (modalConfig.actionType === "approve") {
      const [response] = await approveInventory();
      if (response?.status) {
        showToast(response.message, true);
        window.location.reload();
      } else {
        showToast(response?.message, false);
      }
    } else if (modalConfig.actionType === "delete") {
      const [response] = await deleteInventory();
      if (response?.status) {
        showToast(response.message, true);
        navigate(-1);
      } else {
        showToast(response?.message, false);
      }
    } else if (modalConfig.actionType === "decline") {
      const [response] = await rejectInventory();
      if (response?.status) {
        showToast(response.message, true);
        navigate(-1);
      } else {
        showToast(response?.message, false);
      }
    }
  };

  const handleApprove = () => {
    setModalConfig({
      isVisible: true,
      actionType: "approve",
    });
  };

  const handleRject = () => {
    setModalConfig({
      isVisible: true,
      actionType: "decline",
    });
  };

  const handleDelete = () => {
    setModalConfig({
      isVisible: true,
      actionType: "delete",
    });
  };

  function closeProductrModal() {
    setProductrModal(false);
  }

  function openProductModal() {
    setProductrModal(true);
  }

  return (
    <>
      {profile && <Navbar profile={profile} />}
      <div className="flex justify-between gap-5 mt-5 mx-10">
        <div className="flex gap-4">
          <div
            onClick={() => navigate(-1)}
            className="flex gap-2 font-semibold text-[16px] border-r-2 pr-4 border-separate cursor-pointer "
          >
            <Icon name="appbackIcon" className="mt-1" /> Back to Inventory
          </div>

          <h1 className="md:text-[30px] -mt-2 font-bold">
            {capitalizeFirstLetter(inventory?.name)}
          </h1>
        </div>

        <div className="text-[14px] flex gap-2">


         
          {inventory?.approvalStatus !== "rejected" && (
             <Button
            type="button"
            variant="secondary"
            // className="font-normal flex border gap-1 rounded-full p-2"
            onClick={openProductModal}
          >
            <Icon name="editIconBlack" /> Edit Product
          </Button>
          )}

          {inventory?.approvalStatus === "approved" && (
            <Button
              type="button"
              size="sm"
              variant="tertiary"
              // className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
              onClick={handleDelete}
            >
              <Icon name="markIcon" /> Delete
            </Button>
          )}
          {inventory?.approvalStatus === "rejected" && (
            <Button
              type="button"
              size="lg"
              variant="tertiary"
              // className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
              onClick={handleDelete}
            >
              <Icon name="markIcon" /> Delete
            </Button>
          )}

          {inventory?.approvalStatus === "pending" && (
            <Button
              type="button"
              size="sm"
              variant="tertiary"
              // className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
              onClick={handleRject}
            >
              <Icon name="markIcon" /> Decline
            </Button>
          )}

          {inventory?.approvalStatus === "pending" && (
            <Button
              type="button"
              variant="primary"
              size="sm"
              className="font-normal flex bg-[#047401] text-[#fff] border gap-1 rounded-full p-2"
              onClick={handleApprove}
            >
              <Icon name="cancelIcon" /> Approve
            </Button>
          )}
        </div>
      </div>

      <div className="flex flex-col justify-center items-center mx-10">
        <Tab
          activeTab={activeProduct}
          tabs={["Product Details", "Variants"]}
          setActiveTab={setActiveProduct}
        />
      </div>

      {activeProduct === "Product Details" && (
        <div className="mx-10 my-2">
          <SingleProduct information={inventory} />
        </div>
      )}

      {activeProduct === "Variants" && (
        <div className="mx-10 my-2">
          <VariantsTable data={variants} />
        </div>
      )}

      {loading ? (
        <RingLoader color="#ffffff" loading={loading} size={20} />
      ) : (
        <ActionModal
          visible={modalConfig.isVisible}
          onCancel={() => setModalConfig({ ...modalConfig, isVisible: false })}
          onConfirm={handleConfirmAction}
          title={`Product ${
            modalConfig.actionType === "approve" ? "Approval" : "Deletion"
          }`}
          content={`Are you sure you want to ${modalConfig.actionType} product creation?`}
          actionType={modalConfig.actionType}
        />
      )}

      <AddProductDialog
        isVisible={productrModal}
        onClose={closeProductrModal}
        information={inventory}
      />
    </>
  );
};

export default ProductDetails;
